/* Pooja Ragenee theme · pr-core.js -> window.PR (README section 5). Port of the generic parts of mockup/v3/apple.js:
   config, utils, money, names, colours, sizes, section registry, events, scroll/motion engine (PR.refresh), modal, toast,
   shelf paddles, video control and photo fade-in (also for images inserted later, e.g. after a section swap). */
(function (w, d) {
  'use strict';
  var PR = w.PR = w.PR || {};
  var root = d.documentElement;
  function $(s, el) { return (el || d).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || d).querySelectorAll(s)); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var mq = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  PR.$ = $; PR.$$ = $$; PR.clamp = clamp; PR.esc = esc;
  PR.reduced = function () { return !!(mq && mq.matches); };

  /* 1. Config (#pr-config, printed by sections/pr-header.liquid) ----------------------------------------------- */
  PR.cfg = {
    routes: { root: '/', cart: '/cart', cartJs: '/cart.js', cartAdd: '/cart/add.js', cartChange: '/cart/change.js', search: '/search', suggest: '/search/suggest.json', all: '/collections/all' },
    freeShipFrom: 49900, shipFee: 6000, codFrom: 49900, lowStock: 3, phone: '',
    links: { sizeGuide: '/pages/bra-size-guide-1', shipping: '/policies/shipping-policy', returns: '/policies/refund-policy' },
    copy: {}, popular: [], strings: {}
  };
  (function () { var el = d.getElementById('pr-config'); if (!el) return; try { var c = JSON.parse(el.textContent); for (var k in c) PR.cfg[k] = c[k]; } catch (e) {} })();
  /* PR.t('bag.items', { count: 2 }) -> "2 items"; PR.t('general.no_results', { terms: 'x' }) */
  PR.t = function (key, vars) {
    var s = PR.cfg.strings || {}, v = vars || {}, str;
    if (v.count != null && s[key + '.one'] != null) str = +v.count === 1 ? s[key + '.one'] : String(s[key + '.other'] || '').replace(/999/g, v.count);
    else str = s[key];
    if (str == null) return '';
    return String(str).replace(/\{(\w+)\}/g, function (m, k) { return v[k] != null ? v[k] : m; });
  };

  /* 2. Ready, events, section registry --------------------------------------------------------------------------- */
  var readyQ = [], isReady = false;
  PR.ready = function (fn) { if (isReady) { try { fn(); } catch (e) { if (w.console) console.error(e); } } else readyQ.push(fn); };
  function start() { if (isReady) return; isReady = true; init(); readyQ.splice(0).forEach(PR.ready); }
  /* PR.on('cart', fn): fn(detail) where detail.detail === detail (so fn(e) { e.detail.cart } works too) */
  PR.on = function (name, fn) {
    name = String(name).replace(/^pr:/, '');
    d.addEventListener('pr:' + name, function (e) {
      var x = e.detail;
      if (x && typeof x === 'object') { try { if (!('detail' in x)) Object.defineProperty(x, 'detail', { value: x, enumerable: false }); } catch (er) {} fn(x, e); } else fn(e, e);
    });
  };
  PR.emit = function (name, detail) { try { d.dispatchEvent(new CustomEvent('pr:' + String(name).replace(/^pr:/, ''), { detail: detail || {} })); } catch (e) {} };
  var reg = {};
  function runInit(type, el) { var r = reg[type]; if (!r || !r.init || el._prInit === type) return; el._prInit = type; try { r.init(el); } catch (e) { if (w.console) console.error(e); } }
  PR.sections = {
    register: function (type, init, destroy) {
      reg[type] = { init: init, destroy: destroy };
      PR.ready(function () { $$('[data-pr-section="' + type + '"]').forEach(function (el) { runInit(type, el); }); });
    }
  };
  d.addEventListener('shopify:section:load', function (e) {
    var t = e.target; PR.refresh(t);
    $$('[data-pr-section]', t).forEach(function (el) { runInit(el.getAttribute('data-pr-section'), el); });
  });
  d.addEventListener('shopify:section:unload', function (e) {
    $$('[data-pr-section]', e.target).forEach(function (el) {
      var r = reg[el.getAttribute('data-pr-section')]; if (r && r.destroy) { try { r.destroy(el); } catch (er) {} } el._prInit = null;
    });
  });

  /* 3. Money, icons, names ---------------------------------------------------------------------------------------- */
  /* paise -> ₹1,299 / ₹166.50 (Indian grouping, .00 dropped) */
  PR.money = function (paise) {
    var n = Math.round(Number(paise) || 0), neg = n < 0; n = Math.abs(n);
    var r = Math.floor(n / 100), p = n % 100;
    return (neg ? '-' : '') + '₹' + r.toLocaleString('en-IN') + (p ? '.' + (p < 10 ? '0' : '') + p : '');
  };
  PR.icon = function (name) { return '<svg class="pr-i" aria-hidden="true" focusable="false"><use href="#pr-i-' + name + '"/></svg>'; };
  function data() { return w.PR_DATA || {}; }
  function packOf(h, title) { var n = (data().packs || {})[h]; if (n) return n; var m = /pack of\s*(\d)/i.exec(title || '') || /\b(\d)\s?pc\b/i.exec(title || ''); return m ? +m[1] : 1; }
  /* mockup cleanName: first clause of the title, no "for Women", no "Women's", no style code */
  function cleanName(title, pack) {
    var t = String(title || '').replace(/\(([A-Z]{2,3}\d{3,5}[^)]*)\)\s*$/, '').trim();
    var first = t.split(/\s*[–—|]\s*|\s+-\s+/)[0];
    var fw = /\s+for\s+women\b/i.exec(first); if (fw) first = first.slice(0, fw.index);
    first = first.replace(/^women[’']?s\s+/i, '').replace(/^womens\s+/i, '').replace(/\s+[A-Z]{2,3}\d{3,5}.*$/, '').trim();
    first = first.charAt(0).toUpperCase() + first.slice(1);
    if (pack > 1 && !/pack/i.test(first)) first += ', pack of ' + pack;
    return first;
  }
  PR.name = function (h, title) { var n = (data().names || {})[h]; return n || cleanName(title || '', packOf(h, title)); };
  PR.style = function (h) { return (data().styles || {})[h] || ''; };

  /* 4. Colours (mockup hexFor / swatchBg / dotBg / colorLabel / colourFamily) ----------------------------------- */
  function hexFor(name) {
    var map = data().colours || {}, fb = data().fallbackColour || '#C9C3C6';
    var n = String(name || '').toLowerCase().replace(/\s+/g, ' ').trim().replace(/\s*(flower|graphic)?\s*print(ed)?$/, '').trim();
    if (map[n]) return map[n];
    var words = n.split(' ');
    for (var i = 0; i < words.length; i++) if (map[words.slice(i).join(' ')]) return map[words.slice(i).join(' ')];
    return fb;
  }
  function parts(name) { return String(name || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean); }
  PR.colour = {
    hex: hexFor,
    bg: function (name) {
      var p = parts(name);
      if (p.length > 1) { var step = 360 / p.length; return 'conic-gradient(' + p.map(function (x, i) { return hexFor(x) + ' ' + (i * step) + 'deg ' + ((i + 1) * step) + 'deg'; }).join(',') + ')'; }
      var hex = hexFor(p[0]);
      if (/print/i.test(p[0] || '')) return 'radial-gradient(circle at 30% 30%, rgba(255,255,255,.85) 0 1.5px, transparent 2px) 0 0/7px 7px, ' + hex;
      return hex;
    },
    dot: function (name) {
      var p = parts(name), a = hexFor(p[0]), b = p.length > 1 ? hexFor(p[1]) : /print/i.test(p[0] || '') ? '#F2EEE8' : '';
      return b ? 'linear-gradient(135deg, ' + a + ' 0 50%, ' + b + ' 50% 100%)' : a;
    },
    label: function (name) {
      var s = String(name || '').replace(/\s+/g, ' ').trim().replace(/\s*,\s*/g, ' + ');
      return s.replace(/\b([a-z])/g, function (m) { return m.toUpperCase(); }).replace(/\bN Blue\b/, 'Navy Blue').replace(/\bOnine\b/, 'Onion');
    },
    family: function (name) {
      var n = String(name || '').toLowerCase();
      if (n.indexOf(',') >= 0) return 'Multi';
      if (/print/.test(n)) return 'Print';
      var m = [['Black', /black|charcoal/], ['White', /white/], ['Nude & skin', /skin|nude|beige|almond|sand|tan\b/], ['Pink', /pink|magenta|rose|blush|onion|onine|coral/],
        ['Red & wine', /red|wine|maroon|cherry|mulbery|rust/], ['Purple', /purple|lavender|lavander|plum/], ['Blue', /blue|navy|cyan|turquoise|teal/],
        ['Green', /green/], ['Grey', /grey|fog/], ['Brown', /brown|coffee|gold/]];
      for (var i = 0; i < m.length; i++) if (m[i][1].test(n)) return m[i][0];
      return 'Other';
    }
  };

  /* 5. Sizes: bras by band then cup, then XS..3XL, then Free size ---------------------------------------------------- */
  var CUPS = ['AA', 'A', 'B', 'C', 'D', 'DD', 'E', 'F', 'G'], APPAREL = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];
  function parseBra(s) { var m = /^(\d{2})(AA|A|B|C|DD|D|E|F|G)$/.exec(String(s || '').toUpperCase().replace(/\s+/g, '')); return m ? { band: +m[1], cup: m[2], ci: CUPS.indexOf(m[2]) } : null; }
  function norm(s) { s = String(s || '').toUpperCase().trim(); return s === 'XXL' ? '2XL' : s === 'XXXL' ? '3XL' : /^FREE/.test(s) ? 'Free size' : s; }
  function key(s) { var b = parseBra(s); if (b) return b.band * 10 + b.ci; var i = APPAREL.indexOf(norm(s)); return i >= 0 ? 1000 + i : 2000; }
  PR.size = PR.size || {};
  PR.size.cups = CUPS; PR.size.parse = parseBra; PR.size.norm = norm; PR.size.key = key;
  PR.size.sort = function (a) { return (a || []).slice().sort(function (x, y) { return key(x) - key(y); }); };

  /* 6. Modal (native <dialog class="ap-modal">) and toast ---------------------------------------------------------- */
  function closeChrome() { if (PR.menu && PR.menu.close) PR.menu.close(); if (PR.flyout && PR.flyout.close) PR.flyout.close(); if (PR.search && PR.search.close) PR.search.close(false); }
  PR.closeChrome = closeChrome;
  PR.modal = {
    wire: function (dlg) {
      if (!dlg || dlg._prWired) return; dlg._prWired = true;
      dlg.addEventListener('click', function (e) { if (e.target.closest('[data-ap-close]') || e.target === dlg) PR.modal.close(dlg); });
      dlg.addEventListener('cancel', function (e) { e.preventDefault(); PR.modal.close(dlg); });
      var sheet = $('.ap-modal__sheet', dlg);
      if (sheet && !$('.ap-modal__close', dlg)) sheet.insertAdjacentHTML('afterbegin', '<button type="button" class="ap-icon-btn ap-modal__close" data-ap-close aria-label="' + esc(PR.t('general.close') || 'Close') + '">' + PR.icon('close') + '</button>');
    },
    open: function (dlg, opener) {
      if (typeof dlg === 'string') dlg = d.getElementById(dlg.replace(/^#/, ''));
      if (!dlg) return;
      PR.modal.wire(dlg); closeChrome();
      dlg._prOpener = opener || d.activeElement;
      dlg.classList.remove('is-closing');
      if (dlg.showModal) { if (!dlg.open) dlg.showModal(); } else dlg.setAttribute('open', '');
      d.body.classList.add('ap-lock');
      var sheet = $('.ap-modal__sheet', dlg); if (sheet) sheet.scrollTop = 0; dlg.scrollTop = 0;
      PR.refresh(dlg);
      return dlg;
    },
    close: function (dlg) {
      if (typeof dlg === 'string') dlg = d.getElementById(dlg.replace(/^#/, ''));
      if (!dlg || !dlg.open) return;
      var done = function () {
        dlg.classList.remove('is-closing'); if (dlg.close) dlg.close(); else dlg.removeAttribute('open');
        if (!$('dialog[open]')) d.body.classList.remove('ap-lock');
        var o = dlg._prOpener; dlg._prOpener = null; if (o && o.focus && d.contains(o)) { try { o.focus({ preventScroll: true }); } catch (e) {} }
      };
      if (PR.reduced()) return done();
      dlg.classList.add('is-closing'); setTimeout(done, 280);
    }
  };
  var toastT;
  PR.toast = function (msg) {
    var el = $('[data-pr-toast]');
    if (!el) { el = d.createElement('div'); el.className = 'ap-toast'; el.setAttribute('role', 'status'); el.setAttribute('data-pr-toast', ''); d.body.appendChild(el); }
    el.textContent = msg; el.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  };

  /* 7. Shelf paddles: [data-ap-shelf] wraps .ap-shelf__track (or .ap-hcards__track) --------------------------------- */
  function wireShelf(el) {
    if (el._prShelf) return;
    var track = $('.ap-shelf__track, .ap-hcards__track', el); if (!track) return;
    el._prShelf = true;
    var pad = $('.ap-shelf__paddles, .ap-hcards__paddles', el);
    if (!pad) {
      pad = d.createElement('div'); pad.className = track.classList.contains('ap-hcards__track') ? 'ap-hcards__paddles' : 'ap-shelf__paddles';
      pad.innerHTML = '<button type="button" class="ap-icon-btn" data-dir="-1" aria-label="' + esc(PR.t('general.previous') || 'Previous') + '">' + PR.icon('chevron-left') + '</button>' +
        '<button type="button" class="ap-icon-btn" data-dir="1" aria-label="' + esc(PR.t('general.next') || 'Next') + '">' + PR.icon('chevron-right') + '</button>';
      el.appendChild(pad);
    }
    var prev = $('[data-dir="-1"]', pad), next = $('[data-dir="1"]', pad);
    function step() { var c = track.children[0]; return c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 20) : 300; }
    function upd() { if (prev) prev.disabled = track.scrollLeft < 4; if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
    pad.addEventListener('click', function (e) {
      var b = e.target.closest('[data-dir]'); if (!b) return;
      track.scrollBy({ left: step() * +b.getAttribute('data-dir') * Math.max(1, Math.floor(track.clientWidth / step())), behavior: PR.reduced() ? 'auto' : 'smooth' });
    });
    track.addEventListener('scroll', function () { w.requestAnimationFrame(upd); }, { passive: true });
    w.addEventListener('resize', upd); upd();
  }
  PR.shelf = wireShelf;

  /* 8. Scroll engine ------------------------------------------------------------------------------------------------ */
  var SDA = !!(w.CSS && CSS.supports && CSS.supports('animation-timeline: view()'));
  var revealIO = null, nearIO = null, near = new Set(), pending = [], maxY = 0, ticking = false, frameFns = [];
  function splitWords(el) {
    if (el._prWords) return; el._prWords = true;
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = d.createDocumentFragment();
          n.nodeValue.split(/(\s+)/).forEach(function (t) {
            if (!t) return;
            if (/^\s+$/.test(t)) { frag.appendChild(d.createTextNode(t)); return; }
            var s = d.createElement('span'); s.className = 'w'; s.style.setProperty('--i', i++); s.textContent = t; frag.appendChild(s);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !/^(BR|svg|IMG)$/i.test(n.tagName) && !n.classList.contains('w')) walk(n);
      });
    })(el);
  }
  function crossP(r, vh) { return clamp((vh - r.top) / (vh + r.height), 0, 1); }
  function entryP(r, vh) { return clamp((vh - r.top) / ((vh + r.height) * 0.3), 0, 1); }
  function pinP(r, vh) { var len = r.height - vh; return len > 0 ? clamp(-r.top / len, 0, 1) : (r.top <= 0 ? 1 : 0); }
  /* [data-ap-angles] stacked <img>s; p 0..1 moves frame to frame (data-snap: frames follow the step index) */
  function sequence(el, p) {
    var imgs = el._prImgs || (el._prImgs = $$(':scope > img', el)), k = imgs.length;
    if (k < 2) return;
    var f = p * k, red = PR.reduced();
    if (el.hasAttribute('data-snap')) {
      var idx = clamp(Math.floor(f), 0, k - 1);
      if (el._prIdx !== idx) {
        var dir = el._prIdx == null || idx > el._prIdx ? 1 : -1;
        el._prIdx = idx;
        imgs.forEach(function (img, i) { img.style.setProperty('--dx', (dir * (i === idx ? 3 : -3)) + '%'); img.classList.toggle('is-on', i === idx); img.classList.toggle('is-off', i !== idx); });
      }
    } else {
      var xf = parseFloat(el.getAttribute('data-xfade')) || 0.3;
      imgs.forEach(function (img, i) {
        var t = i === 0 ? 1 : clamp((f - i + xf / 2) / xf, 0, 1);
        img.style.opacity = (red ? (t >= 0.5 ? 1 : 0) : t).toFixed(3);
        if (!red) img.style.transform = 'scale(' + (1.04 - 0.04 * t).toFixed(4) + ')';
      });
    }
    var labels = (el.getAttribute('data-labels') || '').split('|');
    var lab = $('.ap-angles__label', el) || (el.parentNode && $('[data-ap-angles-label]', el.parentNode));
    if (lab && labels.length > 1) lab.textContent = labels[clamp(Math.floor(f), 0, labels.length - 1)] || '';
  }
  PR.scroll = { sequence: sequence, sda: SDA, onFrame: function (fn) { frameFns.push(fn); }, kick: function () { onScroll(); } };
  /* is the band under y (px from the viewport top) dark? .ap-bg-black, .ap-tile--black, a dark ribbon or [data-ap-dark] */
  var DARK = '.ap-bg-black, .ap-tile--black, .ap-ribbon[data-theme="dark"], [data-ap-dark]', darkList = null;
  PR.darkAt = function (y, skip) {
    var list = darkList || (darkList = $$(DARK)), hit = false;
    for (var i = 0; i < list.length && !hit; i++) { if (list[i] === skip || (skip && skip.contains(list[i]))) continue; var r = list[i].getBoundingClientRect(); hit = r.top <= y && r.bottom > y; }
    return hit;
  };
  function reveal(el) { el.classList.add('is-in'); if (revealIO) revealIO.unobserve(el); var i = pending.indexOf(el); if (i >= 0) pending.splice(i, 1); }
  function frame() {
    ticking = false;
    var vh = w.innerHeight, sy = w.scrollY || 0; maxY = Math.max(maxY, sy);
    for (var k = pending.length - 1; k >= 0; k--) if (pending[k].getBoundingClientRect().top + sy < maxY + vh * 0.9) reveal(pending[k]);
    near.forEach(function (el) {
      if (!el.isConnected) { near.delete(el); return; }
      var r = el.getBoundingClientRect();
      if (el.classList.contains('ap-scrolly')) {
        var p = pinP(r, vh);
        el.style.setProperty('--p', p.toFixed(4));
        var steps = el._prSteps || (el._prSteps = $$('[data-step]', el)), ns = 0;
        steps.forEach(function (s) { ns = Math.max(ns, +s.getAttribute('data-step') + 1); });
        if (ns) {
          var idx = Math.min(ns - 1, Math.floor(p * ns));
          if (el.getAttribute('data-step-active') !== String(idx)) {
            el.setAttribute('data-step-active', idx);
            steps.forEach(function (s) { s.classList.toggle('is-active', +s.getAttribute('data-step') === idx); });
            try { el.dispatchEvent(new CustomEvent('ap:step', { bubbles: true, detail: { el: el, index: idx, count: ns } })); } catch (er) {}
          }
        }
        $$('[data-ap-angles]', el).forEach(function (a) { sequence(a, p); });
      } else if (el.classList.contains('scale-in')) el.style.setProperty('--p', PR.reduced() ? 1 : entryP(r, vh).toFixed(4));
      else el.style.setProperty('--p', crossP(r, vh).toFixed(4));
    });
    frameFns.forEach(function (fn) { try { fn(vh); } catch (e) {} });
  }
  function onScroll() { maxY = Math.max(maxY, w.scrollY || 0); if (!ticking) { ticking = true; w.requestAnimationFrame(frame); } }
  function scanMotion(rt) {
    $$('.reveal-words', rt).forEach(splitWords);
    if (!revealIO && 'IntersectionObserver' in w) revealIO = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) reveal(e.target); }); }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
    var design = root.classList.contains('ap-design');
    $$('.reveal, .reveal-words, .sweep', rt).forEach(function (el) {
      if (el._prRv) return; el._prRv = true;
      if (revealIO && !PR.reduced() && !design) { revealIO.observe(el); pending.push(el); } else el.classList.add('is-in');
    });
    if (!nearIO && 'IntersectionObserver' in w) nearIO = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) near.add(e.target); else near.delete(e.target); }); onScroll(); }, { rootMargin: '25% 0px 25% 0px' });
    $$('.ap-scrolly, [data-ap-progress]' + (SDA ? '' : ', .scale-in'), rt).forEach(function (el) { if (el._prTr) return; el._prTr = true; if (nearIO) nearIO.observe(el); else near.add(el); });
    $$('[data-ap-angles]', rt).forEach(function (a) { a._prImgs = null; if (!a.closest('.ap-scrolly') || PR.reduced()) sequence(a, 0); });
    darkList = null;
    $$('[data-ap-video]', rt).forEach(wireVideo);
    onScroll();
  }

  /* 9. Video: [data-ap-video] > video (muted playsinline loop); plays on screen only, never under reduced motion ---- */
  var videoIO = null;
  function wireVideo(box) {
    if (box._prVid) return;
    var v = $('video', box); if (!v) return;
    box._prVid = true;
    v.muted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
    var b = $('.ap-video__ctrl', box);
    if (!b) { b = d.createElement('button'); b.type = 'button'; b.className = 'ap-icon-btn ap-video__ctrl'; box.appendChild(b); }
    box._prUserPaused = PR.reduced();
    function sync() { var on = !v.paused; b.innerHTML = PR.icon(on ? 'pause' : 'play'); b.setAttribute('aria-label', PR.t(on ? 'general.pause' : 'general.play') || (on ? 'Pause video' : 'Play video')); }
    b.addEventListener('click', function () { if (v.paused) { box._prUserPaused = false; v.play().catch(function () {}); } else { box._prUserPaused = true; v.pause(); } });
    v.addEventListener('play', sync); v.addEventListener('pause', sync); sync();
    var end = parseFloat(box.getAttribute('data-loop-end'));
    if (end > 0) v.addEventListener('timeupdate', function () { if (v.currentTime >= end) v.currentTime = 0; });
    if (!videoIO && 'IntersectionObserver' in w) {
      videoIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) { var vv = $('video', e.target); if (!vv) return; if (e.isIntersecting && !e.target._prUserPaused) vv.play().catch(function () {}); else if (!e.isIntersecting) vv.pause(); });
      }, { threshold: 0.25 });
    }
    if (videoIO) videoIO.observe(box);
  }

  /* 10. Photos in .ap-media fade in once decoded; cached photos inserted later (section swaps) are marked too ------ */
  function markImg(img) { if (img && img.classList && img.classList.contains('ap-media__img')) img.classList.add('is-loaded'); }
  d.addEventListener('load', function (e) { markImg(e.target); }, true);
  d.addEventListener('error', function (e) { markImg(e.target); }, true);
  function scanImgs(rt) { $$('.ap-media__img:not(.is-loaded)', rt || d).forEach(function (i) { if (i.complete) markImg(i); }); }
  PR.images = { scan: scanImgs };
  if ('MutationObserver' in w) {
    var moT = 0;
    new MutationObserver(function (ms) {
      var hit = false;
      for (var i = 0; i < ms.length && !hit; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) if (ms[i].addedNodes[j].nodeType === 1) { hit = true; break; }
      if (hit && !moT) moT = w.requestAnimationFrame(function () { moT = 0; scanImgs(d); setTimeout(function () { scanImgs(d); }, 120); });
    }).observe(root, { childList: true, subtree: true });
  }

  /* PR.refresh(root): wire motion, widgets and modals inside root (idempotent) */
  PR.refresh = function (rt) {
    rt = rt || d;
    scanImgs(rt);
    $$('[data-ap-shelf]', rt).forEach(wireShelf);
    $$('dialog.ap-modal', rt).forEach(PR.modal.wire);
    scanMotion(rt);
  };

  /* 11. Init ---------------------------------------------------------------------------------------------------------- */
  root.classList.add('ap-js');
  if (SDA) root.classList.add('ap-sda');
  function setReduced() { root.classList.toggle('ap-reduced', PR.reduced()); }
  setReduced();
  if (mq && mq.addEventListener) mq.addEventListener('change', function () { setReduced(); onScroll(); });
  function init() {
    d.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (a && a.getAttribute('href').length > 1 && !e.defaultPrevented && !a.hasAttribute('data-ap-size-open')) {
        var tgt = null; try { tgt = d.getElementById(decodeURIComponent(a.getAttribute('href').slice(1))); } catch (er) {}
        if (tgt) { e.preventDefault(); tgt.scrollIntoView({ behavior: PR.reduced() ? 'auto' : 'smooth', block: 'start' }); try { history.replaceState(null, '', a.getAttribute('href')); } catch (er) {} return; }
      }
      var t = e.target.closest('[data-ap-modal-open]');
      if (t) { e.preventDefault(); PR.modal.open(t.getAttribute('data-ap-modal-open'), t); }
    });
    w.addEventListener('scroll', onScroll, { passive: true });
    w.addEventListener('resize', onScroll);
    w.addEventListener('load', function () { onScroll(); scanImgs(d); });
    PR.refresh(d);
  }
  if (d.readyState === 'complete') start(); else { d.addEventListener('DOMContentLoaded', start); w.addEventListener('load', start); }
})(window, document);
